import React from 'react';
import WestIcon from '@mui/icons-material/West';
import Heading from '../../component/Heading/Heading';
import { NavLink } from 'react-router';
import logo from "../../assets/icons/logo.svg"
import AuthBg from '../../component/auth/AuthBg';
import "../../styles/pages/auth/signUp.scss"
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const ExpireInvitation = () => {
    const { t } = useTranslation();
    return (
        <div className="auth send-otp" >
            <div className="signup-container">
                <Grid container>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }} className='min-vh-100'>
                        <div className="logo-container">
                            <img src={logo} alt="logo" className='company-logo' /></div>
                        <div className="signup-data">
                            <div className="input-container">
                                <div className='send-otp-data'>
                                    <Heading text={t('common_text_expire_invitation')} />
                                    <p>{t('common_text_expire_invitation_support_admin')}</p>
                                    <p className='send-mail'>{""}</p>

                                    <div className='flex Back-login-btn'>
                                        <p><WestIcon className='left-arrow-icon' /> </p>
                                        <p className='Back-login-data'><NavLink to="/signIn" className='text-black'>{t("common_text_back_to_login")}</NavLink></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6, lg: 8 }} className="signup-img-padding">
                        <AuthBg />
                    </Grid>
                </Grid>
            </div>
        </div >
    );
}

export default ExpireInvitation;
